import { Form } from 'antd';
import { Button, Input } from '@bancobarigui/barihaus';
import { MailOutlined, LockOutlined } from '@ant-design/icons';

import { LoginFormData } from '../useLogin';

interface Props {
  onSubmit: (data: LoginFormData) => void;
  loading: boolean;
}

export function LoginForm({ onSubmit, loading }: Props): JSX.Element {
  const [form] = Form.useForm();

  const handleFinish = (values: LoginFormData) => {
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      onFinish={handleFinish}
      className="flex flex-col w-full gap-1"
      autoComplete="on"
      layout="vertical"
    >
      <Form.Item
        name="email"
        label={<span className="text-slate-600 font-medium">Email</span>}
        rules={[
          { type: 'email', message: 'Por favor, insira um email válido.' },
          { required: true, message: 'Por favor, informe seu email.' },
        ]}
      >
        <Input
          prefix={<MailOutlined className="text-slate-400 mr-2" />}
          placeholder="seu@email.com"
          disabled={loading}
          autoComplete="email"
          className="!py-3 !px-4 !rounded-xl !border-slate-200 hover:!border-blue-400 focus:!border-blue-500 !transition-all"
        />
      </Form.Item>

      <Form.Item
        name="password"
        label={<span className="text-slate-600 font-medium">Senha</span>}
        rules={[
          { required: true, message: 'Por favor, informe sua senha.' },
          { min: 8, message: 'A senha deve ter no mínimo 8 dígitos.' },
        ]}
      >
        <Input
          prefix={<LockOutlined className="text-slate-400 mr-2" />}
          type="password"
          placeholder="Digite sua senha"
          disabled={loading}
          autoComplete="current-password"
          className="!py-3 !px-4 !rounded-xl !border-slate-200 hover:!border-blue-400 focus:!border-blue-500 !transition-all"
        />
      </Form.Item>

      <Form.Item className="!mt-4 !mb-0">
        <Button
          block
          htmlType="submit"
          loading={loading}
          disabled={loading}
          className="!h-12 !rounded-xl !text-base !font-semibold !border-0 !bg-[#0090ff] hover:!bg-[#0077d5] !text-white disabled:!bg-[#0090ff] disabled:!text-white disabled:!opacity-80"
        >
          {loading ? 'Entrando...' : 'Entrar'}
        </Button>
      </Form.Item>
    </Form>
  );
}
